import JSencrypt from 'jsencrypt'

const RSA_PUBLIC_KEY = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGkUieabBcWphSpB0SHJDFj4tP
gQMai7kruG0/mzLfR9LHD2MStCwt2P70GTdvXIlolNmvNf4goAt6MpDAl6O5K1nX
Ffxi6fQnJmRKRAi/ok10Xc4kVbgUohlNyC55V6JY7IjJVYvBV4oigkujHHOjJGBh
UKqdCkbor4jNl8fvIQIDAQAB
-----END PUBLIC KEY-----
`;

const RSA_PRIVATE_KEY = '';

export default {

    /**
     * 加密文本
     * @param str
     * @returns {string | false}
     */
    encode(str) {
        let encryptor = new JSencrypt();
        encryptor.setPublicKey(RSA_PUBLIC_KEY);
        return encryptor.encrypt(str);
    },

    /**
     * 解密文本
     * @param encryptStr
     * @returns {string | false}
     */
    decode(encryptStr) {
        let decrypt = new JSencrypt();
        decrypt.setPrivateKey(RSA_PRIVATE_KEY);
        return decrypt.decrypt(encryptStr);
    }
}


// WEBPACK FOOTER //
// ./src/common/encrypt.js